<template>
    <div class="popularType-main newUi">
        <div class="popularType_content flexColumn">
            <div class="content_top flex">
                <div class="content_center flexColumn" style="padding: 10px;justify-content: space-between;">
                    <div class="content_style" style="height: 100%;">
                        <div class="newUiHeaderDP">
                            施工图纸
                        </div>
                        <div class="style_content">
                            <div style="height: 100%; width: 100%; justify-content: space-between;" class="flex">
                                <div style="height: 100%; width: 15%;">
                                    <div class="content_style" style="height: 100%;">
                                        <el-aside width="100%" style="height: 100%;overflow:hidden">
                                            <zTreeZN :zNodes="sgzNodes" zTreeRemenuId="zTreeRemenuId1"
                                                @getData="getDataList" @addFileZtree="addFileZtree" :options="{
                                                    id: 'id',
                                                    pid: 'parentid',
                                                    label: 'tname',
                                                    zTreeId: 'PdeptTree',
                                                    delType: {
                                                        add: false,
                                                        update: false,
                                                        del: false,
                                                        addFile: upOrdelUsersgAuthority,
                                                    },
                                                }" ref="zTree" style="height: 99%;" />
                                        </el-aside>
                                    </div>
                                </div>
                                <div style="height: 100%; width: 84%;">
                                    <div class="content_style" style="height: 100%;">
                                        <el-table :data="dataListsg" highlight-current-row height="100%"
                                            :header-cell-style="{
                                                background: '#71A5D0',
                                                color: '#fff',
                                                textAlign: 'center',
                                            }" :cell-style="{ textAlign: 'center' }">
                                            <el-table-column type="index" label="序号" width="55">
                                            </el-table-column>
                                            <el-table-column prop="fname" label="图纸名称" width="450">
                                                <template slot-scope="scope">
                                                    <el-tooltip class="item" :disabled="scope.row.fname.length > 30 ? false : true
                                                        " effect="dark" :content="scope.row.fname"
                                                        placement="top-start">
                                                        <el-button size="small" type="text" class="wirte"
                                                            @click="lookImage(scope.row)">{{
                                                                scope.row.fname.length > 30
                                                                    ? scope.row.fname.substr(0, 30)
                                                                    : scope.row.fname
                                                            }}</el-button>
                                                    </el-tooltip>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="ext" label="文件格式">
                                            </el-table-column>
                                            <el-table-column prop="version" label="版本信息"></el-table-column>
                                            <!-- <el-table-column prop="createtime" label="上传时间"
                                                width="160"></el-table-column> -->
                                            <el-table-column prop="status" label="操作" width="230">
                                                <template slot-scope="scope">
                                                    <el-button size="small" type="primary" plain
                                                        @click="feedbackChange(scope.row, 0)">反馈</el-button>
                                                    <el-button v-if="downUsersgAuthority" size="small" type="primary"
                                                        plain @click="downChange(scope.row, 0)">下载</el-button>
                                                    <el-button v-if="upOrdelUsersgAuthority ||
                                                        scope.row.createuserid == uid
                                                    " size="small" type="warning" plain
                                                        @click="delChange(scope.row.id, 0)">删除</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_left flexColumn">
                    <div class="content_style" style="height: 100%;">
                        <div class="newUiHeaderDP">
                            问题反馈清单
                        </div>
                        <div class="style_content">
                            <el-table :data="feedbackListsg" highlight-current-row height="100%" :header-cell-style="{
                                background: '#71A5D0',
                                color: '#fff',
                                textAlign: 'center',
                            }" :cell-style="{ textAlign: 'center' }">
                                <el-table-column prop="title" label="标题">
                                    <template slot-scope="scope">
                                        <el-button size="small" type="text" class="wirte"
                                            @click="questionChange(scope.row, 0)" :title="scope.row.title">{{
                                                scope.row.title }}</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="username" label="指定回复人">
                                    <template slot-scope="scope">
                                        {{scope.row.replayusers.map((i) => i.user04).join("、")}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content_bottom flex">
                <div class="content_center flexColumn" style="padding: 10px;justify-content: space-between;">
                    <div class="content_style" style="height: 100%;">
                        <div class="newUiHeaderDP">
                            竣工图纸
                        </div>
                        <div class="style_content">
                            <div style="height: 100%; width: 100%; justify-content: space-between;" class="flex">
                                <div style="height: 100%; width: 15%;">
                                    <div class="content_style" style="height: 100%;">
                                        <el-aside width="100%" style="overflow:hidden;height: 100%;">
                                            <zTreeZN :zNodes="jgzNodes" zTreeRemenuId="zTreeRemenuId2"
                                                @getData="getDataList1" @addFileZtree="addFileZtree" :options="{
                                                    id: 'id',
                                                    pid: 'parentid',
                                                    label: 'tname',
                                                    zTreeId: 'PdeptTree1',
                                                    delType: {
                                                        add: false,
                                                        update: false,
                                                        del: false,
                                                        addFile: upOrdelUserjgAuthority,
                                                    },
                                                }" ref="zTree1" style="height: 99%;" />
                                        </el-aside>
                                    </div>
                                </div>
                                <div style="height: 100%; width: 84%;">
                                    <div class="content_style" style="height: 100%;">
                                        <el-table :data="dataListjg" highlight-current-row height="100%"
                                            :header-cell-style="{
                                                background: '#71A5D0',
                                                color: '#fff',
                                                textAlign: 'center',
                                            }" :cell-style="{ textAlign: 'center' }">
                                            <el-table-column type="index" label="序号" width="55">
                                            </el-table-column>
                                            <el-table-column prop="fname" label="图纸名称" width="450">
                                                <template slot-scope="scope">
                                                    <el-tooltip class="item" :disabled="scope.row.fname.length > 30 ? false : true
                                                        " effect="dark" :content="scope.row.fname"
                                                        placement="top-start">
                                                        <el-button size="small" type="text" class="wirte"
                                                            @click="lookImage(scope.row)">{{
                                                                scope.row.fname.length > 30
                                                                    ? scope.row.fname.substr(0, 30)
                                                                    : scope.row.fname
                                                            }}</el-button>
                                                    </el-tooltip>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="ext" label="文件格式"></el-table-column>
                                            <el-table-column prop="version" label="版本信息"></el-table-column>
                                            <!-- <el-table-column prop="createtime" label="上传时间"
                                                width="160"></el-table-column> -->
                                            <el-table-column prop="status" label="操作" width="230">
                                                <template slot-scope="scope">
                                                    <el-button size="small" type="primary" plain
                                                        @click="feedbackChange(scope.row, 1)">反馈</el-button>
                                                    <el-button size="small" v-if="downUserjgAuthority" type="primary"
                                                        plain @click="downChange(scope.row, 1)">下载</el-button>
                                                    <el-button size="small" v-if="upOrdelUserjgAuthority ||
                                                        scope.row.createuserid == uid
                                                    " type="warning" plain
                                                        @click="delChange(scope.row.id, 1)">删除</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_left flexColumn">
                    <div class="content_style" style="height: 100%;">
                        <div class="newUiHeaderDP">
                            问题反馈清单
                        </div>
                        <div class="style_content">
                            <el-table :data="feedbackListjg" highlight-current-row height="100%" :header-cell-style="{
                                background: '#71A5D0',
                                color: '#fff',
                                textAlign: 'center',
                            }" :cell-style="{ textAlign: 'center' }">
                                <el-table-column prop="title" label="标题">
                                    <template slot-scope="scope">
                                        <el-button size="small" type="text" class="wirte"
                                            @click="questionChange(scope.row, 1)" :title="scope.row.title">{{
                                                scope.row.title
                                            }}</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="username" label="指定回复人">
                                    <template slot-scope="scope">
                                        {{scope.row.replayusers.map((i) => i.user04).join("、")}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 预览 -->
        <LookIframe ref="iframebaseRef"></LookIframe>
        <!-- 新增文件 -->
        <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" :title="'新增' + Addtitle"
            :visible.sync="ADDFileShow" width="50%" height="50%" :before-close="handleClose" class="inputStyle">
            <div class="head-text">
                <el-upload ref="upload" v-model="fileList1" :show-file-list="false" multiple class="upload-demo"
                    accept=".pdf,.dwg" :action="actionUrl" :on-change="handleChange" :before-upload="beforeUpload">
                    <el-button size="medium" style="color: #333;">点击选择文件</el-button>
                </el-upload>
                <el-row>
                    <el-col :span="5" style="text-align: center;">图纸名称</el-col>
                    <el-col :span="6" :offset="1" style="text-align: center;">文件格式</el-col>
                    <el-col :span="5" :offset="1" style="text-align: center;"><span style="color: red;">*</span>
                        版本信息</el-col>
                    <el-col :span="5" :offset="1"></el-col>
                </el-row>
                <el-row v-for="(item, index) in fileList" :key="index" style="top: -20px;">
                    <el-col :span="5" style="text-align: center;">
                        <el-tooltip class="item" :disabled="item.name.length > 20 ? false : true" effect="dark"
                            :content="item.name" placement="top-start">
                            <el-button type="text">{{
                                item.name.length > 20 ? item.name.substr(0, 20) : item.name
                                }}</el-button>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="6" :offset="1" style="text-align: center;">
                        <el-button type="text" style="color:#000">{{
                            item.name.split(".")[1]
                            }}</el-button>
                    </el-col>
                    <el-col :span="6" :offset="1" style="text-align: center;">
                        <el-input placeholder="必填，文本框，手动输入" v-model="item.versions">
                        </el-input>
                    </el-col>
                    <el-col :span="4" :offset="1">
                        <i class="el-icon-delete" v-if="fileList.length > 0" style="font-size: 30px; color: red;"
                            @click="fileList.splice(index, 1)"></i>
                    </el-col>
                </el-row>
            </div>
            <el-row>
                <el-col :span="2" :offset="22">
                    <el-button type="primary" @click="submitUpdata()">确定</el-button>
                </el-col>
            </el-row>
        </el-dialog>
        <!-- 反馈 -->
        <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="反馈" :visible.sync="feedbackShow"
            width="55%" height="50%" :before-close="handleClose" class="inputStyle">
            <el-form :model="feedbackForm" :rules="feedbackRule" ref="Updatefeedback" label-width="200px"
                class="demo-ruleForm mar-r80" style="padding-right: 60px;">
                <el-form-item label="关联文件：" prop="fileName">
                    <el-input disabled v-model="feedbackForm.fileName" placeholder="必填，文本，手动输入"></el-input>
                </el-form-item>
                <el-form-item label="问题反馈清单标题：" prop="title">
                    <el-input type="text" maxlength="30" v-model="feedbackForm.title"
                        placeholder="请输入标题，限制30个汉字"></el-input>
                </el-form-item>
                <el-form-item label="问题反馈清单内容：" prop="strcount">
                    <ckediter4 ref="ck" v-model="feedbackForm.strcount" :disable="false"></ckediter4>
                </el-form-item>
            </el-form>
            <el-row>
                <el-col :span="2" :offset="21">
                    <el-button type="primary" style="width: 100%;"
                        @click="submitfeedback('Updatefeedback')">确定</el-button>
                </el-col>
            </el-row>
        </el-dialog>
        <!-- 反馈问题回复预览 -->
        <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="问题反馈清单预览"
            :visible.sync="ShowQuestion" width="80%" >
            <el-form :model="questionForm" label-width="150px" ref="addForm2"
                style="padding-right: 60px;height: 650px;overflow-y: auto;">
                <el-form-item label="关联文件：">
                    <div>
                        {{ questionForm.ywprojectfile != null ? questionForm.ywprojectfile.fname : "关联文件已被删除" }}
                    </div>
                </el-form-item>
                <el-form-item label="问题反馈清单标题：">
                    <div>{{ questionForm.title }}</div>
                </el-form-item>
                <el-row style="padding:0px">
                    <el-col :span="6">
                        <el-form-item label="清单状态：">
                            <div>{{ questionForm.strstatus }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <!-- <el-form-item label="关闭时间：">
                            <div>
                                {{ questionForm.status != 2 ? "未关闭" : questionForm.colsetime }}
                            </div>
                        </el-form-item> -->
                    </el-col>
                </el-row>
                <el-row style="padding:0px;margin-top: 20px;" v-for="(item, index) in questionForm.disposelsit"
                    :key="index">
                    <el-col :span="12">
                        <el-row style="padding:0px">
                            <el-col :span="12">
                                <el-form-item :label="index == 0 ? '发起人：' : '追问人：'">
                                    <div>{{ item.fbusername }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <!-- <el-form-item :label="index == 0 ? '发起时间：' : '追问时间：'">
                                    <div>{{ item.fbdate }}</div>
                                </el-form-item> -->
                            </el-col>
                        </el-row>
                        <el-form-item label="问题反馈清单内容：">
                            <ckediter4 v-model="item.fbcontent" :disable="true"></ckediter4>
                        </el-form-item>
                    </el-col>

                    <template
                        v-if="questionForm.creatuser == uid && (fbtype == 0 ? replyUsersgAuthority : replyUserjgAuthority)">
                        <el-col :span="12">
                            <el-row style="padding:0px">
                                <el-col :span="12">
                                    <el-form-item label="回复人：">
                                        <div>{{ item.disusername }}</div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <!-- <el-form-item label="回复时间：">
                                        <div>
                                            {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                                        </div>
                                    </el-form-item> -->
                                </el-col>
                            </el-row>
                            <el-form-item label="回复内容：" prop="disposecontent">
                                <ckediter4 ref="ck" v-model="item.disposecontent"
                                    :disable="item.disposecontent != null ? true : false">
                                </ckediter4>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2" :offset="22"
                            v-if="item.disusername == null && index + 1 == questionForm.disposelsit.length">
                            <el-button type="primary" style="width: 100%;"
                                @click="questionBtn(item, false, index)">确定</el-button>
                        </el-col>
                        <el-col :span="4" :offset="20" v-else>
                            <div style="float: right;" v-if="index + 1 == questionForm.disposelsit.length">
                                <el-button style="color:#333" @click="continueBtn()">继续追问</el-button>
                                <el-button type="primary" v-show="zwStatus == true"
                                    @click="questionBtn(item, true, index)">关闭问题</el-button>
                            </div>
                        </el-col>
                    </template>
                    <template v-else>
                        <template
                            v-if="!(index + 1 == questionForm.disposelsit.length && (fbtype == 0 ? replyUsersgAuthority : replyUserjgAuthority) == false) || item.disposecontent != null">
                            <el-col :span="12">
                                <el-row style="padding:0px">
                                    <el-col :span="12">
                                        <el-form-item label="回复人：">
                                            <div>{{ item.disusername }}</div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="回复时间：">
                                            <div>
                                                {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="回复内容：" prop="disposecontent">
                                    <ckediter4 ref="ck" v-model="item.disposecontent"
                                        :disable="item.disposecontent != null ? true : questionDisable">
                                    </ckediter4>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" :offset="20"
                                v-if="questionForm.creatuser == uid && index + 1 == questionForm.disposelsit.length">
                                <div style="float: right;">
                                    <el-button style="color:#333" @click="continueBtn()">继续追问</el-button>
                                    <el-button type="primary" v-show="zwStatus == true"
                                        @click="questionBtn(item, true, index)">关闭问题</el-button>
                                </div>
                            </el-col>
                            <el-col :span="2" :offset="22" v-else>
                                <el-button
                                    v-if="item.disusername == null && index + 1 == questionForm.disposelsit.length"
                                    type="primary" style="width: 100%;"
                                    @click="questionBtn(item, false, index)">确定</el-button>
                            </el-col>
                        </template>
                    </template>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="zwStatus == false">
                        <el-form-item label="问题反馈清单内容:">
                            <ckediter4 ref="ck2" v-model="newFeedback.fbcontent" :disable="zwStatus"></ckediter4>
                            <el-col :span="2" :offset="21">
                                <el-button style="margin-top:10px" type="primary" @click="questionBtn1()">确定</el-button>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="图纸展示"
            :visible.sync="drawingsIsShow" width="70%">
            <div id="modelShow"></div>
        </el-dialog>
    </div>
</template>

<script>
import zTreeZN from "@//components/zTreeZN.vue";
import ckediter4 from "@/components/ck.vue";
import LookIframe from "@/components/LookIframe.vue";
import { download } from "@/tools/tool";
import {
    GetywproTreeList,
    GetYwFilesList,
    GetYWProUserAuth,
    AddYwFilesWithTree,
    DelYwFilesList,
    AddYwFeedback,
    GetYwFeedbackList,
    YWFbAskedAndReply,
    ViewYwDrawings,
    TransformYwDrawings
} from "@/setAxios.js";
export default {
    name: "popularType",
    components: { zTreeZN, ckediter4, LookIframe },
    data() {
        return {
            uid: Number(localStorage.getItem("id")),
            id: null,
            sgzNodes: null,
            jgzNodes: null,
            loading: false,
            Addtitle: "",
            Addtype: null,
            titleNum: "1",
            ADDFileShow: false,
            dataListsg: [],
            dataListjg: [],
            fileList: [],
            fileList1: [],
            actionUrl: this.$store.state.baseUrl,
            // 人员权限
            upOrdelUsersg: [],
            upOrdelUserjg: [],
            downUsersg: [],
            downUserjg: [],
            replyUsersg: [],
            replyUserjg: [],
            //预览
            ShowImage: false,
            src:
                "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
            // 反馈
            feedbackListsg: [],
            feedbackListjg: [],
            feedbackShow: false,
            feedbackForm: {},
            feedbackRule: {
                fileName: [{ required: true, message: "请输入", trigger: "blur" }],
                title: [{ required: true, message: "请输入", trigger: "blur" }],
                strcount: [{ required: true, message: "请输入", trigger: "blur" }],
            },
            ShowQuestion: false,
            questionForm: {
                ywprojectfile: {},
            },
            fbtype: null,
            questionDisable: false,
            replayStatus: false, //回复状态
            submitStatus: false, //确认状态
            zwStatus: true, //追问状态
            newFeedback: {},
            drawingsIsShow: false,
        };
    },
    computed: {
        upOrdelUsersgAuthority() {
            return this.upOrdelUsersg.includes(Number(localStorage.getItem("id")));
        },
        downUsersgAuthority() {
            return this.downUsersg.includes(Number(localStorage.getItem("id")));
        },
        replyUsersgAuthority() {
            return this.replyUsersg.includes(Number(localStorage.getItem("id")));
        },
        //竣工
        upOrdelUserjgAuthority() {
            return this.upOrdelUserjg.includes(Number(localStorage.getItem("id")));
        },
        downUserjgAuthority() {
            return this.downUserjg.includes(Number(localStorage.getItem("id")));
        },
        replyUserjgAuthority() {
            return this.replyUserjg.includes(Number(localStorage.getItem("id")));
        },
    },
    methods: {
        handleClose(done) {
            // this.feedbackShow = false;
            // this.ADDFileShow = false;
            // this.ShowQuestion = false;
            // this.questionDisable = !this.questionDisable;
            // this.submitStatus = false;
            // this.$refs.upload.clearFiles();
            this.feedbackShow = false;
            this.ADDFileShow = false;
            this.ShowQuestion = false;
            this.questionDisable = !this.questionDisable;
            this.submitStatus = false;
            this.replayStatus = true;
            this.zwStatus = true;
            this.questionForm = {};
            this.$refs.upload.clearFiles();
            done();
        },
        // 文件树
        async GetywproTree(type) {
            if (type === 1) {
                let res = await GetywproTreeList({
                    params: { xid: this.$store.state.xid, type: type },
                });
                this.sgzNodes = res.Data;
            } else {
                let res = await GetywproTreeList({
                    params: { xid: this.$store.state.xid, type: type },
                });
                this.jgzNodes = res.Data;
            }
        },
        // 获取列表
        async getDataList(ids) {
            this.loading = true;
            let params = {
                fname: "",
                xid: this.$store.state.xid,
                type: 1,
                treeid: ids,
                pageindex: 1,
                pageSize: 99999,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            let res = await GetYwFilesList(fd);
            this.loading = false;
            this.dataListsg = res.Data.length > 0 ? res.Data : [];
        },
        async getDataList1(ids) {
            this.loading = true;
            let params = {
                fname: "",
                xid: this.$store.state.xid,
                type: 2,
                treeid: ids,
                pageindex: 1,
                pageSize: 99999,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            let res = await GetYwFilesList(fd);
            this.loading = false;
            this.dataListjg = res.Data.length > 0 ? res.Data : [];
        },
        // 获取项目过程模块人员权限
        GetYWProUserAuthUser(type) {
            let params = {
                xid: this.$store.state.xid,
                type: type,
            };
            GetYWProUserAuth({ params }).then((res) => {
                if (res.Data) {
                    if (type == 1) {
                        this.upOrdelUsersg =
                            res.Data.insertuids != null
                                ? res.Data.insertuids.split(",").map(Number)
                                : [];
                        this.downUsersg =
                            res.Data.downloaduids != null
                                ? res.Data.downloaduids.split(",").map(Number)
                                : [];
                    } else if (type == 2) {
                        this.replyUsersg =
                            res.Data.replyuids != null
                                ? res.Data.replyuids.split(",").map(Number)
                                : [];
                    } else if (type == 3) {
                        this.upOrdelUserjg =
                            res.Data.insertuids != null
                                ? res.Data.insertuids.split(",").map(Number)
                                : [];
                        this.downUserjg =
                            res.Data.downloaduids != null
                                ? res.Data.downloaduids.split(",").map(Number)
                                : [];
                    } else if (type == 4) {
                        this.replyUserjg =
                            res.Data.replyuids != null
                                ? res.Data.replyuids.split(",").map(Number)
                                : [];
                    }
                }
            });
        },
        addFileZtree(id, data) {
            this.ADDFileShow = true;
            this.Addtitle = data.tname;
            this.Addtype = data.type;
            this.id = data.id;
            this.fileList = [];
        },
        // 添加文件
        submitUpdata() {
            for (let i = 0; i < this.fileList.length; i++) {
                const e = this.fileList[i];
                if (e.versions == "") {
                    this.$message.error("请填写完成数据!");
                    return;
                }
            }
            let fd = new FormData();
            this.fileList.forEach((file) => {
                fd.append(`${file.name}^@^${file.versions}`, file.raw);
            });
            fd.append("xid", this.$store.state.xid);
            fd.append("type", this.Addtype);
            fd.append("targetId", this.id);
            AddYwFilesWithTree(fd).then((res) => {
                if (res.Code != 0) {
                    this.$message.success("上传成功");
                    this.ADDFileShow = false;
                    this.$refs.upload.clearFiles();
                    this.Addtype == 1 ? this.getDataList() : this.getDataList1();
                } else {
                    this.$message.error(res.Message);
                }
            });
        },
        handleChange(file, fileList) {
            fileList.forEach((item) => {
                this.$set(item, "versions", "");
            });
            this.fileList = fileList;
        },
        beforeUpload(file) {
            var index = file.name.lastIndexOf(".");
            var suffix = file.name.substring(index + 1);
            var suffixs = ["pdf", "dwg"];
            if (suffixs.indexOf(suffix) == -1) {
                this.$message({
                    message: "上传文件只能是pdf、dwg格式!",
                    type: "warning",
                });
                return false;
            }
            return true;
        },
        // 预览
        lookImage(data) {
            if (data.ext == '.dwg') {
                this.ViewDrawings(data.id)
            } else {
                this.$refs.iframebaseRef.LookItemPics(data.fpath);
            }
        },
        async ViewDrawings(id) {
            this.tips = null;
            var res = await ViewYwDrawings({ id });
            if (res.Code == 0) {
                this.tips = this.$notify({
                    message: res.Message,
                    duration: 0,
                    type: "success",
                });
                let params = {
                    qid: localStorage.pid,
                    id,
                };
                var res = await TransformYwDrawings(params);
                if (res.Code == 0) {
                    this.$message({
                        type: "warning",
                        message: res.Message,
                    });
                    this.tips.close();
                } else {
                    this.$notify({
                        message: res.Message,
                        type: "success",
                    });
                    this.tips.close();
                    this.showModel(res.Data.fchangepath);
                }
            } else if (res.Code == 1) {
                this.$message({
                    message: res.Message,
                    type: "warning",
                });
            } else if (res.Code == 2) {
                this.showModel(res.Data.fchangepath);
            }
        },
        showModel(url) {
            this.drawingsIsShow = true;
            this.$nextTick(() => {
                var _this = this;
                var config = {
                    disabledExtensions: {
                        measure: false,
                        section: false,
                    },
                    memory: {
                        limit: 32 * 1024, //32 GB
                    },
                    theme: "light-theme",
                };
                var element = document.getElementById("modelShow");
                _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
                    element,
                    config
                );
                var options = {
                    docid: this.$store.state.baseUrl + url,
                    env: "Local",
                    offline: "true",
                    useADP: false,
                };

                Autodesk.Viewing.Initializer(options, function () {
                    _this.viewer.start();
                    _this.viewer.loadModel(options.docid, {
                        isAEC: true,
                    });
                    _this.viewer.addEventListener(
                        Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
                        function () {
                            // _this.$message({
                            //   type: "success",
                            //   message: "模型加载完成",
                            // });
                        }
                    );
                });
            });
        },
        // 反馈
        feedbackChange(data, type) {
            if (type == 0 && this.replyUsersg.length == 0) {
                this.$message.warning("请联系管理员设置指定回复人！")
                return false;
            }
            if (type == 1 && this.replyUserjg.length == 0) {
                this.$message.warning("请联系管理员设置指定回复人！")
                return false;
            }
            this.feedbackShow = true;
            this.feedbackForm = {
                fileId: data.id,
                fileName: data.fname,
                title: "",
                strcount: "",
                type: type,
            };
        },
        GetFeedbackList(type) {
            let params = {
                searchword: "",
                projectid: this.$store.state.xid,
                type: type,
                status: -1,
                pageindex: 1,
                pagesize: 99999,
                treeid: 0,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            GetYwFeedbackList(fd).then((res) => {
                // 过滤已关闭
                if (res.Data) {
                    if (type == 0) {
                        this.feedbackListsg =
                            res.Data.length > 0
                                ? res.Data.filter((el) => el.strstatus != "已关闭")
                                : [];
                    } else if (type == 1) {
                        this.feedbackListjg =
                            res.Data.length > 0
                                ? res.Data.filter((el) => el.strstatus != "已关闭")
                                : [];
                    }
                }
            });
        },
        submitfeedback(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid && this.feedbackForm.strcount.length > 0) {
                    let fd = new FormData();
                    this.feedbackForm.strcount = this.$refs.ck.ckeditor.getData();
                    fd.append("projectid", this.$store.state.xid);
                    // fd.append("type", 2);
                    fd.append("type", this.feedbackForm.type);
                    fd.append("fileId", this.feedbackForm.fileId);
                    fd.append("title", this.feedbackForm.title);
                    fd.append("strcount", this.feedbackForm.strcount);
                    AddYwFeedback(fd).then((res) => {
                        if (res.Code != 0) {
                            this.feedbackForm.type === 0
                                ? this.GetFeedbackList(0)
                                : this.GetFeedbackList(1);
                            this.$message.success("上传成功");
                            this.feedbackForm = {};
                            this.feedbackShow = false;
                        } else {
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    this.$message.error("验证失败！");
                    return false;
                }
            });
        },
        // 做反馈操作
        questionChange(data, type) {
            this.questionForm = data;
            this.fbtype = type;
            //回复人员
            if (
                type === 0
                    ? this.replyUsersg.includes(Number(localStorage.getItem("id"))) ===
                    true ||
                    this.questionForm.creatuser === Number(localStorage.getItem("id"))
                    : this.replyUserjg.includes(Number(localStorage.getItem("id"))) ===
                    true ||
                    this.questionForm.creatuser === Number(localStorage.getItem("id"))
            ) {
                // 权限
                //状态回复设置
                if (data.status === 0) {
                    //
                    this.replayStatus = false;
                    this.questionDisable = false;
                    this.submitStatus = false;
                } else if (data.status === 1) {
                    //回复待确认
                    this.replayStatus = true;
                    this.questionDisable = true;
                    this.submitStatus = true;
                    this.zwStatus = true;
                } else if (data.status === 2) {
                    //已关闭
                    this.submitStatus = true;
                    this.questionDisable = true;
                    this.replayStatus = false;
                }
            } else {
                this.questionDisable = true;
                this.replayStatus = false;
                // this.submitStatus = true;
            }
            this.ShowQuestion = true;
        },
        // 确认回复
        questionBtn(data, status, index) {
            let result = false;
            console.log('this.questionForm.disposelsit: ', this.questionForm.disposelsit);
            this.questionForm.disposelsit.forEach((el) => {
                if (el.disposecontent != null) {
                    console.log('el.disposecontent: ', el.disposecontent);
                    // 都不为空
                    result = true;
                } else {
                    // 有空数据
                    this.$message.error("请填写完成数据!");
                    result = false;
                }
                return result;
            });
            // result, true为不空,false为空
            if (result) {
                data.disposecontent = this.$refs.ck[index].ckeditor.getData();
                let params = {
                    fbid: this.questionForm.id,
                    projectid: this.$store.state.xid,
                    type: this.fbtype,
                    isclose: status,
                    disposeid: data.id,
                    strcontent: !status ? data.disposecontent : ''
                };
                let fd = new FormData();
                for (var key in params) {
                    fd.append(key, params[key]);
                }
                YWFbAskedAndReply(fd).then((res) => {
                    if (res.Code != 0) {
                        this.$message.success("操作成功");
                        this.ShowQuestion = false;
                        this.replayStatus = true;
                        this.questionDisable = true;
                        this.submitStatus = false;
                        this.fbtype === 0
                            ? this.GetFeedbackList(0)
                            : this.GetFeedbackList(1);
                    } else {
                        this.$message.error(res.Message);
                    }
                });
            }
        },
        // 追问
        continueBtn(data) {
            this.newFeedback = {
                id: 0,
                feedbackid: this.questionForm.id,
                fbcontent: "",
            };
            this.zwStatus = false;
        },
        // 确认回复
        questionBtn1() {
            this.newFeedback.fbcontent = this.$refs.ck2.ckeditor.getData();
            let params = {
                fbid: this.newFeedback.feedbackid,
                projectid: this.$store.state.xid,
                type: this.fbtype,
                isclose: false,
                disposeid: 0,
                strcontent: this.newFeedback.fbcontent,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            YWFbAskedAndReply(fd).then((res) => {
                if (res.Code != 0) {
                    this.$message.success("操作成功");
                    this.ShowQuestion = false;
                    this.zwStatus = true;
                    this.fbtype === 0 ? this.GetFeedbackList(0) : this.GetFeedbackList(1);
                } else {
                    this.$message.error(res.Message);
                }
            });
        },
        //下载
        downChange(data) {
            let name = data.fname.slice(data.fname.lastIndexOf("/") + 1);
            try {
                download(
                    this.$store.state.baseUrl + data.fpath,
                    name + data.fpath.substr(data.fpath.lastIndexOf("."))
                );
            } catch (error) {
                this.$message.error("导出失败");
            }
        },
        // 删除
        delChange(id, type) {
            this.$confirm("此操作将移除所选文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        ids: id,
                    };
                    DelYwFilesList(params).then((res) => {
                        if (res.Code > 0) {
                            this.$message({
                                type: "success",
                                message: "移除成功!",
                            });
                        }
                        type === 0 ? this.getDataList() : this.getDataList1();
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                    this.loading = false;
                });
        },
    },
    created() {
        this.GetYWProUserAuthUser(1);
        this.GetYWProUserAuthUser(2);
        this.GetYWProUserAuthUser(3);
        this.GetYWProUserAuthUser(4);
        this.GetywproTree(1);
        this.GetywproTree(2);
        this.getDataList();
        this.getDataList1();
        this.GetFeedbackList(0);
        this.GetFeedbackList(1);
    },
};
</script>
<style lang="less" scoped>
.popularType-main {
    width: 100%;
    height: calc(100% - 10px);
    padding-top: 10px;

    .popularType_content {
        width: 100%;
        height: 100%;

        .content_top {
            width: 100%;
            height: 50%;
        }

        .content_bottom {
            width: 100%;
            height: 50%;
        }

        .content_left {
            width: 25%;
            height: 100%;
        }

        .content_center {
            width: 75%;
            height: 100%;
        }
    }

    .wirte {
        color: #fff;
        font-size: 13px;
    }

    .flex {
        width: 100%;
    }

    .menuStyle {
        background-image: url("../../../assets/img/Wisdom/Group\ 1901.png");
        background-repeat: no-repeat;
        background-position: center center;
        cursor: pointer;
        padding: 0px 40px;
        box-sizing: content-box;
        width: 14%;
        height: 100%;
        color: #fff;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .isActive {
        background-image: url("../../../assets/img/Wisdom/Group\ 3_1.png");
    }

    .content_style {
        width: 100%;
        height: 33%;

        .style_title {
            background-image: url("../../../assets/img/A三期/大屏/min.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            font-size: 14px;
            padding: 10px 55px;
            font-weight: bold;
            color: #fff;
        }

        .style_content {
            height: calc(100% - 74px);
            margin-top: 10px;
            background-color: rgba(0, 133, 247, 0.1);
            width: calc(100% -20px);
            padding: 10px;
            color: #fff;

            .bj_1 {
                background-image: url("../../../assets/img/Wisdom/椭圆\ 1\ 拷贝\ 31\ 灰大素材\ 拷贝\ 1.png");
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                text-align: center;
                font-weight: bold;
                width: 40%;
                height: 30%;
            }

            .bj_2 {
                background-image: url("../../../assets/img/Wisdom/1\ 86006.png");
                background-repeat: no-repeat;
                background-size: contain;
                background-position: 10% center;
                text-align: center;
                font-weight: bold;
                padding: 8px;
                letter-spacing: 5px;
                font-size: 20px;
                text-align: center;
                color: #04e8f8;
                font-family: "fzfs" !important;
            }

            .tian {
                position: relative;

                &::after {
                    position: absolute;
                    content: "天";
                    right: -30%;
                    color: #fff;
                    bottom: 2px;
                }
            }
        }
    }

    .style_title2 {
        background-image: url("../../../assets/img/A三期/大屏/min2.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-family: "fzfs";
        font-size: 14px;
        padding: 10px 55px;
        font-weight: bold;
        color: #fff;
    }

    // 走马灯--图标改变
    .swiper {
        width: 80%;
        height: 100%;
    }

    .el-carousel__container {
        height: 100%;
    }

    .left-img1 {
        margin-right: 5px;
        cursor: pointer;
    }

    .right-img1 {
        margin-left: 5px;
        cursor: pointer;
    }

    .el-carousel__arrow--left,
    .el-carousel__arrow--right {
        display: none;
    }

    .el-carousel__item {
        width: 100%;

        .carousek {
            width: 100%;

            .carousel_Title {
                width: 100%;
                height: 40px;
                margin-top: 10px;
                font-size: 15px;
                justify-content: flex-start;
                padding-left: 10px;
                background-image: url("../../../assets/img/Intelligence/Group\ 2091.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                /* 设置背景图片的位置以及重复方式 */
                background-position: center top;
            }

            .carousel_content {
                height: 55%;
                margin-top: 10px;

                .content_mian {
                    width: 80%;
                    height: 70%;
                    margin-left: 10px;
                    font-size: 12px;
                }
            }
        }
    }

    /deep/.inputStyle .el-input.is-disabled .el-input__inner {
        color: #ccc !important;
    }

    /deep/.inputStyle .el-input .el-input__inner {
        color: #333 !important;
        /* 修改为你想要的颜色 */
    }

    .font_col2 {
        margin-left: 10px;
        color: #4edce1;
    }
}

#modelShow {
    width: 90%;
    margin-left: 5%;
    position: relative;
    height: 600px;
    // display: inline-flex;
}
</style>
